import { render } from "./CrewAdd.vue?vue&type=template&id=3fb019cc"
import script from "./CrewAdd.vue?vue&type=script&lang=js"
export * from "./CrewAdd.vue?vue&type=script&lang=js"
script.render = render

export default script